import { Box, Button, Container, FormControl, Grid, InputLabel, NativeSelect, TextField, Typography } from '@mui/material';
import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import React, { useEffect } from 'react'
import {useState} from 'react'
import { API_URL } from '../../Config';

const Mymembership = () => {
    const [collection,setcollection] = useState([]);
    const {account}=useWeb3React();

    const handleSubmit=async(e)=>{
        e.preventDefault();
        const file =e.target.folder.files;
        const startdate = e.target.startdate.value;
        const endate = e.target.enddate.value;
        const royalty = e.target.royalty.value;
        let price = e.target.price.value;
        let collection =e.target.collection.value;
        let id = Math.floor(Math.random() * 1000000);
        var data = new FormData();
        data.append("collection_name",collection);
        data.append("folder",file);
        data.append("Start_date",startdate);
        data.append("End_date",endate);
        data.append("Royalty",royalty);
        data.append("Price",price);
        data.append("id",id);

        await axios.post(`${API_URL}/savemembernft.php`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }).then((result)=>{
           
          })
    }

    const handleChange = e => {
        const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0], "UTF-8");
        fileReader.onload = e => {
         console.log(e.target.files,"filess")
        };
      };
  
      const collectiondata = async () => {
          var data = new FormData();
          data.append("address",account)
          data.append("action","fetchlazycollection");
  
          await axios
          .post(`${API_URL}/createCollection.php`, data ,{
              headers: {
                  "Content-Type": "multipart/form-data",
              },
          })
          .then(async (req) => {
     
             if (req.data) {
              setcollection(req.data);
              }
          })
          
      };
  
      useEffect(() => {
          if(collection.length ==0){
              collectiondata();
          }
       
      }, [collection ,account]);

    return (
        <div>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        My Membership
                    </Typography>
                </Box>
            </Box>

            <Container maxWidth='lg' component='form' method='post'  onSubmit={handleSubmit} >
                <Grid container spacing={2} className='form_inner'>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Typography variant='h5' fontWeight='600' fontSize='25px'> All NFT Details </Typography>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>Add NFT</label>
                        <br></br>
                        <input type="file" name="folder" className="form-control" id="customFile" webkitdirectory="true"  onChange={handleChange} />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label className='add_n'>No of NFT Drop</label>
                        <TextField id="outlined-basic" name='drop' fullWidth />
                    </Grid>
                    <Grid  item lg={6} sm={6} md={6} xs={12}>
                        <FormControl fullWidth>
                            <InputLabel variant="standard" htmlFor="uncontrolled-native">
                            </InputLabel>
                                <NativeSelect  defaultValue="BNB" name="collection">
                                   {collection && collection.map((option,idx)=>(
                                       <option  key={idx} value={option.collection_name} >{option.collection_name}</option>  
                                    ))}
                                </NativeSelect>
                        </FormControl>
                        </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Typography variant='h5' fontWeight='600' fontSize='25px'> Self NFT Drops </Typography>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>

                        <label>Start Date</label>
                        <TextField id="outlined-basic" type='date' fullWidth name='startdate' />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label>End Date</label>
                        <TextField id="outlined-basic" type='date' fullWidth name='enddate'/>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label>NFT Royalty</label>
                        <TextField id="outlined-basic" type='number' fullWidth name='royalty' />
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                        <label>Price</label>
                        <TextField id="outlined-basic" type='number' fullWidth name='price'/>
                    </Grid>
                    <Grid item lg={12} sm={12} md={12} xs={12}>
                        <Button variant='contained' type="submit">Submit</Button>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

export default Mymembership;